define([
	"dojo/_base/declare",
	"csi/heading/AggregateController"
], function(declare,AggregateController) {

	return declare(AggregateController, {
		preProcess: function() {
			// summary: refresh cached store when supplier is selected as it effects next selection
			this.widget.refreshHeadingStore(this.heading);
			this.inherited(arguments);
		}
	});
});
